import { useSyncExternalStore } from 'react'

const noopSubscribe = () => () => undefined
const returnUndefined = () => undefined
export const createVariantHook = <T extends string>(
  getVariant: () => T | undefined
): (() => T | undefined) => {
  const useVariant = () =>
    useSyncExternalStore(noopSubscribe, getVariant, returnUndefined)
  return useVariant
}
